import request from '@/utils/request'

// 查询店铺配置列表
export function queryShopSetting(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSetting/queryShopSetting',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询店铺配置key
export function queryShopSettingKey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSettingKey/queryShopSettingKey',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加店铺配置
export function saveShopSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSetting/saveShopSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改店铺配置
export function updateShopSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSetting/updateShopSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除店铺配置
export function deleteShopSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSetting/deleteShopSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}